import React from 'react'
import Logo from '../../assets/img/letape-sunmoonlake-banne2-logo.png';

const Banner = ({language}) => {
    return (
        <section className="letape-sunmoonlake-banner">
            <div className="letape-sunmoonlake-header">
                <h1>{language === "Chinese" ? "L’Étape 日月潭站" : "L’ÉTAPE SUN MOON LAKE"}</h1>
            </div>
            <div className="letape-sunmoonlake-banner-2 text-center">
                <img src={Logo} alt="" />
                <h2>SUN MOON LAKE</h2>
                <h3>Heart of Formosa</h3>
                {language === "Chinese" ?
                    <p>
                        2026年，環法自行車挑戰賽第三度登場日月潭——全球極富盛名的自行車路線之一，<br/>
                        讓來自國內外的好朋友都能在這片土地共襄盛舉，感受環法魅力。 <br/>
                        日月潭為全島境內最大天然湖泊，湖水源自於合歡山，層巒疊嶂、湖面波光粼粼就像是鑲嵌在土地上的綠寶石。<br/>
                        本年度的環法挑戰賽由法國的環法路線專家親自場勘設計、讓國際賽事規格落地在日月潭。<br/>
                        活動結合日月潭在地元素與環法風格，打造出屬於這塊土地的環法盛宴！
                    </p> : <p className='px-4'>
                        In 2026, this prestigious sporting event returns to Sun Moon Lake for its third edition, on one of the world's most renowned cycling routes.<br/>
                        We invite friends from Taiwan and abroad to come together here and experience the magic of the Tour de France.<br />
                        Sun Moon Lake is Taiwan's largest natural lake, fed by waters from Hehuanshan. <br />
                        Framed by layer upon layer of mountains, its shimmering waters look like an emerald set into the land.<br />
                        This year's L'Étape Sun Moon Lake features a route personally surveyed and designed by Tour de France route experts from France, bringing international race standards to Sun Moon Lake. Blending local Sun Moon Lake character with Tour de France style, the event creates a Tour de France celebration unique to this land!
                </p>}
            </div>
        </section>
    )
}

export default Banner